
  <template>
     <div class="json-container">
      <codemirror
          v-model="jsonData"
          :extensions="extensions"
          :editable="false" 
        />
    </div> 
</template>

<script>
import { Codemirror } from 'vue-codemirror';
import { json } from "@codemirror/lang-json";
import { EditorView } from '@codemirror/view';
import { mapState } from 'vuex';


export default {
  name: 'JsonTemplate',
  components: {
      Codemirror
    },
  computed: {
    ...mapState(['emailData']),
    extensions() {
        // Konfiguration für das HTML Syntax-Highlighting
        return [
          json(), 
          EditorView.lineWrapping,  
          EditorView.editable.of(false),
         ];
      },
      jsonData(){
        return JSON.stringify(this.emailData, null, 2)
      }
  }
}
</script>

<style scoped>
.json-container {
  border: 1px solid #ddd;
    border-radius: 4px;
    padding: 10px;
    text-align: left;
    background: white;
}

</style>